import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import AnonymousBlankSlate from 'modules/surveys/components/Analytics/AnonymousBlankSlate'
import AnswersModal from 'modules/surveys/components/Analytics/ScoreResults/_AnswersModal'
import Head from 'modules/surveys/components/Analytics/ScoreResults/_Head'
import Bars from 'modules/surveys/components/Analytics/ScoreResults/charts/Bars'
import Pie from 'modules/surveys/components/Analytics/ScoreResults/charts/Pie'
import type { Answer } from 'modules/surveys/components/Analytics/ScoreResults/hooks'
import {
  useAnswers,
  useSingleChoiceBarsData,
  useSingleChoicePieData,
} from 'modules/surveys/components/Analytics/ScoreResults/hooks'
import { useAnalytics } from 'modules/surveys/pages/Show/hooks'
import type { Question } from 'modules/surveys/store/models/AnalyticResult'

const OPTIONS_THRESHOLD = 10
interface ChartProps {
  answers: Answer[]
  onClick?: (value: string) => void
}

const BarsChart = observer(({ answers, onClick }: ChartProps) => {
  const { data, maxValue, minValue } = useSingleChoiceBarsData(answers).get()

  return <Bars data={data} minValue={minValue} maxValue={maxValue} onClick={onClick} />
})

const PieChart = observer(({ answers, onClick }: ChartProps) => {
  const data = useSingleChoicePieData(answers).get()

  return <Pie data={data} onClick={onClick} />
})
interface Props {
  question: Question
}

const SingleChoice = ({ question }: Props) => {
  const { analyticResult, form, cycle } = useAnalytics()
  const questionGroups = analyticResult?.questionGroupsInCycle(cycle) ?? []
  const answers: Answer[] = useAnswers(question, questionGroups).get()
  const showBars = question.options && question.options.length > OPTIONS_THRESHOLD

  const [modalOpen, setModalOpen] = useState(false)
  const [modalAnswers, setModalAnswers] = useState<Answer[]>([])

  const onClick = (answer_label: number | string) => {
    setModalAnswers(answers.filter((answer) => answer.value === answer_label))
    setModalOpen(true)
  }

  const isAnonymous = form.isAnonymous
  const filtered = answers.filter((val) => {
    return val.value
  })
  return (
    <Box
      background="grey200"
      borderRadius={{
        all: 'abs008',
      }}
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
    >
      <Head answers={answers} question={question} />
      <Box
        border={{
          top: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
      >
        {isAnonymous && !filtered.length ? (
          <AnonymousBlankSlate />
        ) : (
          <>
            {!showBars && (
              <PieChart answers={answers} onClick={!isAnonymous ? onClick : undefined} />
            )}
            {showBars && (
              <BarsChart answers={answers} onClick={!isAnonymous ? onClick : undefined} />
            )}
          </>
        )}
      </Box>
      {modalOpen && (
        <AnswersModal
          question={question}
          answers={modalAnswers}
          onClose={() => setModalOpen(false)}
        />
      )}
    </Box>
  )
}

export default observer(SingleChoice)
